/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { SHARE_MARKETING_MD } from '../../data/markdown/marketing';
import { useShareDataConsentMutation } from '../../graphql/types';
import { Button } from '../button/button';
import { CheckBox } from '../checkbox/checkbox';
import { Heading } from '../heading/heading';
import {
  Actions,
  CheckboxItem,
  Content,
  Copy,
  Form,
  Host,
  Sticky,
} from './shared';

interface MarketingOptinProps {
  onComplete(): void;
}

export function MarketingOptin({ onComplete }: MarketingOptinProps) {
  const [shareDataConsent] = useShareDataConsentMutation();
  const [wineOpportunities, setWineOpportunities] = useState(false);
  const [nvv, setNvv] = useState(false);
  const [vintner, setVintner] = useState(false);
  const [optionsShown, setOptionsShown] = useState(false);
  const hasChanged = wineOpportunities || nvv || vintner;

  const onShareSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    shareDataConsent({
      variables: {
        // wineOpportunities,
        nvv,
        vintner,
      },
      onCompleted: () => onComplete(),
    });
    return false;
  };

  return (
    <Host>
      <Content>
        <Heading center>Lot Detail Sharing Opt-In</Heading>
        <Copy>
          <a href="#" title="Skip this step" onClick={() => onComplete()}>
            Click here to skip this step and continue to the auction.
          </a>
          <br />
          <br />
          <ReactMarkdown>{SHARE_MARKETING_MD}</ReactMarkdown>
        </Copy>
      </Content>

      <Sticky>
        <Form onSubmit={onShareSubmit}>
          {optionsShown && (
            <div>
              <CheckboxItem>
                <CheckBox
                  checked={wineOpportunities}
                  onChange={(e) => setWineOpportunities(e.target.checked)}
                >
                  I would like my registered name and lot details to be shared
                  with Collective Napa Valley and the wineries whose lots I bid
                  on so they may contact me about other opportunities to the
                  wine I bid on.
                </CheckBox>
              </CheckboxItem>
              <CheckboxItem>
                <CheckBox
                  checked={nvv}
                  onChange={(e) => setNvv(e.target.checked)}
                >
                  I would like my registered name and lot details to be shared
                  with Collective Napa Valley so they may send me details about
                  products or services, events, promotions and other activities
                  that may be of interest to me via email, phone or post.
                </CheckBox>
              </CheckboxItem>
              <CheckboxItem>
                <CheckBox
                  checked={vintner}
                  onChange={(e) => setVintner(e.target.checked)}
                >
                  I would like my registered name and lot details to be shared
                  with the wineries whose wine I bid on so they may send me
                  details about products or services, events, promotions and
                  other activities that may be of interest to me.
                </CheckBox>
              </CheckboxItem>
            </div>
          )}
          {hasChanged ? (
            <Actions>
              <Button
                variant="secondary"
                onClick={() => onComplete()}
                fullWidth
              >
                Skip this step
              </Button>
              <Button fullWidth>Continue with choices</Button>
            </Actions>
          ) : (
            <Actions>
              <Button
                type="button"
                variant="secondary"
                onClick={() => setOptionsShown((x) => !x)}
                fullWidth
              >
                {optionsShown ? 'Hide Options' : 'Show Options'}
              </Button>
              <Button onClick={() => onComplete()} fullWidth>
                Skip this step
              </Button>
            </Actions>
          )}
        </Form>
      </Sticky>
    </Host>
  );
}
